import React, { useState, useEffect, useRef, lazy } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Avatar from './avatar.jpg';
import { InterveneActions } from '../../Services/_actions/Intervene/intervene.actions.js';
import {
  channelListAtom,
  chatCountsAtom,
  interveneFilterAtom,
  messageListAtom,
  // isMobileDeviceAtom,
  organisationFilterAtom,
  organisationResponseAtom,
  showMobileViewAtom,
  userDetailAtom,
  userInformationAtom,
  userJourneyAtom,
  userListAtom,
} from '../../Services/_states/index.js';
import { useRecoilState, useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil';
const SelectDropdown = lazy(() => import('../Shared/SelectDropdown/index.jsx'));
const DataNotFound = lazy(() => import('../Shared/DataNotFound/index.jsx'));
const ModalForms = lazy(() => import('../Shared/Modals/index.js'));
import CommonBadges from '../Shared/Badges/index';
import Countdown from './CountDown/index.jsx';
import FilterOffcanvas from '../Shared/FilterOffcanvas/index';
import {
  CampaignListActions,
  ConstantActions,
  FlowBuilderActions,
} from '../../Services/_actions/index.js';
import OrganisationBotSelectionModal from '../Modals/OrganisationBotSelectionModal/index.tsx';
import SearchableDropdown from '../FlowBuilder/Common/SearchableDropdown/SearchableDropdown.tsx';
import {
  Typography,
  Box,
  IconButton,
  Tabs,
  Tab,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Avatar as MuiAvatar,
  Badge,
  TextField,
  useMediaQuery,
  Tooltip,
  Skeleton,
  CircularProgress,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { useSnackBar } from '../FlowBuilder/Common/SnackBar/index.tsx';
import SearchBox from '../FlowBuilder/Common/SearchBox/index.tsx';
import { Padding } from '@mui/icons-material';
import SearchIcon from '@mui/icons-material/Search';
import ChatIcon from '@mui/icons-material/Chat';
import SensorsIcon from '@mui/icons-material/Sensors';

const UserList = () => {
  const actions = InterveneActions();
  const navigate = useNavigate();
  const { tab: activeTabFromRoute } = useParams();
  const campaignActions = CampaignListActions();
  const listInnerRef = useRef();
  // const [chatCounts, setChatCounts] = useState({
  //   intervene: 0,
  //   min_15: 0,
  //   hrs_24: 0,
  //   history: 0,
  //   total: 0,
  // });
  const [chatCounts, setChatCounts] = useRecoilState(chatCountsAtom);

  const TAB_KEY_MAP = {
    intervene: 'intervene',
    '15-min': 'min_15',
    active: 'hrs_24',
    history: 'total',
  };
  const VALID_TAB_ROUTES = Object.keys(TAB_KEY_MAP);
  const resolvedRouteTab = VALID_TAB_ROUTES.includes(activeTabFromRoute)
    ? activeTabFromRoute
    : null;

  const TabPillLabel = ({ text, count = 0, selected = false }) => (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      {/* Pill */}
      <Box
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          px: 1,
          height: 30,
          minWidth: 69,
          borderRadius: '999px',
          fontWeight: 500,
          letterSpacing: 0.2,
          textTransform: 'uppercase',
          fontSize: 11,
          lineHeight: 1,
          ...(selected
            ? { bgcolor: 'primary.main', color: '#fff' }
            : { bgcolor: '#fff', color: '#555', border: '1px solid #c9c9c9' }),
        }}
      >
        {text}
      </Box>

      {/* Small count bubble */}
      {count > 0 && (
        <Box
          sx={{
            position: 'absolute',
            top: -15,
            right: 2,
            width: '23px',
            height: '23px',
            lineHeight: 1,
            padding: '1px',
            borderRadius: '50%',
            bgcolor: 'common.white',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 10,
            fontWeight: 400,
            border: '1.5px solid',
            borderColor: selected ? '#1631B1' : '#c9c9c9',
            color: selected ? '#1631B1' : '#555',
          }}
        >
          {count}
        </Box>
      )}
    </Box>
  );

  const loadChatCounts = async (botNumber) => {
    if (!botNumber) return;
    try {
      const res = await actions.refreshChatCounts(botNumber);
      const data = res?.data ?? res;
      const totals = data?.user_counts ?? {};
      setChatCounts({
        intervene: Number(totals?.intervene) || 0,
        min_15: Number(totals?.min_15) || 0,
        hrs_24: Number(totals?.hrs_24) || 0,
        history: Number(totals?.history) || 0,
        total: Number(totals?.total) || 0,
      });
    } catch (e) {
      setChatCounts({ intervene: 0, min_15: 0, hrs_24: 0, history: 0, total: 0 });
    }
  };
  const [userList, setUserList] = useRecoilState(userListAtom);
  console.log("userList", userList)
  const [userDetails, setUserDetails] = useRecoilState(userDetailAtom);
  const [filters, setFilters] = useRecoilState(interveneFilterAtom);
  const setMessageListState = useSetRecoilState(messageListAtom);
  const loggedInUser = useRecoilValue(userInformationAtom);
  const resetUserJourney = useResetRecoilState(userJourneyAtom);
  const [showMobileView, setShowMobileView] = useRecoilState(showMobileViewAtom);
  // const isMobile = useRecoilValue(isMobileDeviceAtom);
  const isMobile = !useMediaQuery('(max-width:1024px)');
  const [channelList, setChannelList] = useRecoilState(channelListAtom);
  const [isUseEffectCall, setIsUseEffectCall] = useState(true);
  const [campaignList, setCampaignList] = useState({});
  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const [filterForCamapign, setFilterForCamapign] = React.useState({
    to: loggedInUser?.id,
    include_assigned_by: 0,
    fetch_all: 0,
    next_page: 1,
    search: '',
  });
  const [isDataLoading, setIsDataLoading] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isEditModeModal, setIsEditModeModal] = useState(false);
  const [organisationRes, setOrganisationRes] = useRecoilState(organisationResponseAtom);
  const [organisationFilter, setOrganisationFilter] = useRecoilState(organisationFilterAtom);
  const flowBuilderActions = FlowBuilderActions();
  const { showSnackBar } = useSnackBar();
  const constantActions = ConstantActions();
  const [editIconEnable, setEditIconEnable] = useState(() => {
    try {
      const raw = localStorage.getItem('interveneFilters');
      const savedFilterObj = raw ? JSON.parse(raw) : null;
      return Boolean(savedFilterObj?.editIconEnable);
    } catch (e) {
      return false;
    }
  });
  const [interveneStatus, setInterveneStatus] = useState({});
  const manuallySelectedRef = useRef(false);
  const initialLoadDoneRef = useRef(false);
  const isFetchingRef = useRef(false);

  const onSelectUser = async (item, index) => {
    if (item?.phone_number == userDetails?.phone_number) return null;
    manuallySelectedRef.current = true;
    setMessageListState((prev) => ({
      ...prev,
      messages: [],
      total_count: 0,
      filters: {
        ...prev.filters,
        page: 1,
        phone_number: item?.phone_number,
        bot_number: item?.bot_number ?? '',
        chat_type: '',
        intervened_by: '',
      },
    }));
    const isSessionOngoing = item?.intervene && item?.session_start;
    const updatedStatus = { ...interveneStatus, [item?.phone_number]: !isSessionOngoing };
    setInterveneStatus(updatedStatus);
    await actions.getUserDetailByNumber(item);

    setIsUseEffectCall(false);
    resetUserJourney();
    setShowMobileView({ ...showMobileView, userProfile: false });
    if (!isMobile) setShowMobileView({ ...showMobileView, userList: false, messageBox: true });
    // setTimeout(() => {
    if (userList?.users?.length) {
      const newData = [...userList?.users];
      newData[index] = { ...newData[index], not_read_count: 0 };
      setUserList({ ...userList, users: newData });
    }
    // }, 1000);
  };

  const getUserSummaryList = async (data) => {
    if (isFetchingRef.current) return;
    isFetchingRef.current = true;
    setIsDataLoading(true);
    //  await new Promise((resolve) => setTimeout(resolve, 5000)); 
    await actions.getUserListV1(data);
    setIsDataLoading(false);
    isFetchingRef.current = false;
  };

  const handleSearch = async (e) => {
    setFilters((prev) => ({ ...prev, search: e, resetUserList: true, page: 1 }));
    if (e.length > 2 || !e)
      getUserSummaryList({ ...filters, search: e, resetUserList: true, page: 1 });
  };

  const onScroll = () => {
    if (userList?.total_count > 10 && Math.ceil(userList?.total_count / 10) > filters.page) {
      if (listInnerRef.current) {
        const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;
        if (scrollTop + clientHeight >= scrollHeight - 50) {
          setFilters((prev) => ({ ...prev, page: prev.page + 1 }));
          getUserSummaryList({ ...filters, page: filters.page + 1, resetUserList: false });
        }
      }
    }
  };

  //   const changeUserType = (data) => {
  //   if (filters?.userType === data) return null;
  //   setUserList({});
  //   getUserSummaryList({ ...filters, userType: data, page: 1, search: '' });
  //   setFilters({ ...filters, userType: data, page: 1, search: '', phone_number: '' });
  //   setUserDetails({});
  //   // loadChatCounts(filters?.botNumber || filters?.channelObj?.wa_phone_number);
  // };

  const changeUserType = (data, options = {}) => {
    const { shouldNavigate = true, forceReload = false, skipFetch = false } = options;
    if (!VALID_TAB_ROUTES.includes(data)) return null;
    if (filters?.userType === data && !forceReload) return null;

    setUserList({
      users: [],
      total_count: 0,
    });

    setUserDetails({});

    const nextFilters = { ...filters, userType: data, page: 1, search: '', phone_number: '' };
    // setUserList({});

    setFilters((prev) => ({ ...prev, userType: data, page: 1, search: '', phone_number: '' }));

    if (!forceReload) {
      setUserDetails({});
      manuallySelectedRef.current = false;
    }

    if (currentBotNumber && !skipFetch) getUserSummaryList(nextFilters); // ← skippable
    if (shouldNavigate) navigate(`/r/intervene-dashboard/${data}`);
  };

  const handleCloseModal = (data) => {
    if (data) {
      setEditIconEnable(Boolean(data?.editIconEnable));
      const nextUserType = resolvedRouteTab || filters?.userType || 'active';
      const nextFilters = {
        ...filters,
        userType: nextUserType,
        channelObj: data?.botNumber,
        botNumber: data?.botNumber?.wa_phone_number,
        organisationObj: data?.organisation || null,
        resetUserList: true,
        page: 1,
      };
      localStorage.setItem('interveneFilters', JSON.stringify(data || {}));
      setUserDetails({});
      setModalOpen(false);
      setFilters((prev) => ({
        ...prev,
        userType: nextUserType,
        channelObj: data?.botNumber,
        botNumber: data?.botNumber?.wa_phone_number,
        organisationObj: data?.organisation || null,
        resetUserList: true,
        page: 1,
      }));
      getUserSummaryList(nextFilters);
      const bn = data?.botNumber?.wa_phone_number || data?.botNumber?.channel_number;
      loadChatCounts(bn);
      initialLoadDoneRef.current = true;
    } else if (isEditModeModal) {
      setModalOpen(false);
    }
  };

  const currentBotNumber =
    filters?.botNumber ||
    filters?.channelObj?.wa_phone_number ||
    filters?.channelObj?.channel_number;

  useEffect(() => {
    if (currentBotNumber && initialLoadDoneRef.current) {
      loadChatCounts(currentBotNumber);
    }
  }, [
    // filters?.userType,
    filters?.botNumber,
    filters?.channelObj?.wa_phone_number,
    filters?.channelObj?.channel_number,
    // userDetails?.intervene,
    // userDetails?.session_start,
  ]);

  useEffect(() => {
    if (!activeTabFromRoute || !VALID_TAB_ROUTES.includes(activeTabFromRoute)) return;
    changeUserType(activeTabFromRoute, {
      shouldNavigate: false,
      forceReload: true,
      skipFetch: true,
    });
  }, [activeTabFromRoute]);
  useEffect(() => {
    // ✅ FIX: If a user is already selected and still exists in list, don't auto-switch
    if (userDetails?.phone_number) {
      const stillInList = userList?.users?.some((u) => u.phone_number === userDetails.phone_number);
      if (stillInList) return;
    }
    if (manuallySelectedRef.current) return;
    if (
      Object.keys(userDetails)?.length === 0 &&
      isMobile &&
      userList?.users?.length > 0 &&
      isUseEffectCall
      // !manuallySelectedRef.current
    ) {
      onSelectUser(userList?.users[0], 0);
    }
  }, [userList]);

  const fetchChannels = async (organisation) => {
    setChannelList([]);
    try {
      let res = await flowBuilderActions.whatsappBusinessAccounts(organisation?.organisation_id);
      if (res?.status === 200) {
        setChannelList(res?.data || []);
        if (res?.data?.length === 1) {
          handleCloseModal({ botNumber: res?.data[0], editIconEnable: true });
          setEditIconEnable(true);
        } else if (res?.data?.length === 0) {
          handleCloseModal(null);
          showSnackBar('Bot number is not available for this organisation:', 'error');
        } else {
          setModalOpen(true);
        }
      } else {
        showSnackBar('Unexpected response structure or status:', 'error');
      }
    } catch (error) {
      showSnackBar(error?.toString(), 'error');
    }
  };

  const fetchOrganisations = async (filterObj) => {
    if (!loggedInUser?.is_superuser) {
      fetchChannels(loggedInUser?.profile?.organisation);
      return;
    }
    try {
      const res = await constantActions.getOrganisationsWithPagination(filterObj);
      if (res?.status === 200 && res?.data) {
        setOrganisationFilter({ ...organisationFilter, page: organisationFilter.page + 1 });
        setOrganisationRes(res?.data);
        if (res?.data?.list?.length === 1) {
          // setFilterObj({ ...filterObj, botNumber: "", organisation: res?.data?.list[0]?.organisation_id, organisationObj: res?.data?.list[0], botNumberObj: null });
          fetchChannels(res?.data?.list[0]);
        } else if (res?.data?.list?.length === 0) {
          fetchChannels(loggedInUser?.profile?.organisation);
        } else {
          setModalOpen(true);
        }
      } else {
        showSnackBar('Unexpected response status or data:', 'error');
      }
    } catch (error) {
      showSnackBar('Failed to fetch organizations:', 'error');
    }
  };
  useEffect(() => {
    let savedFilterObj = null;
    try {
      const raw = localStorage.getItem('interveneFilters');
      savedFilterObj = raw ? JSON.parse(raw) : null;
    } catch (e) {
      localStorage.removeItem('interveneFilters');
      savedFilterObj = null;
    }

    if (savedFilterObj && savedFilterObj?.botNumber) {
      handleCloseModal(savedFilterObj);
      setEditIconEnable(savedFilterObj?.editIconEnable || false);
      const bn =
        savedFilterObj?.botNumber?.wa_phone_number || savedFilterObj?.botNumber?.channel_number;
      // loadChatCounts(bn);
    } else {
      fetchOrganisations(organisationFilter);
    }
  }, []);

  const compressStr = (str) => {
    if (!str || typeof str !== 'string') return '';
    return str.length > 20 ? `${str.substring(0, 20)}...` : str;
  };

  const getMessageData = (msg) => {
    if (!msg || typeof msg !== 'object') return '';

    const type = msg?.type?.toUpperCase?.() || '';

    switch (type) {
      case 'TEXT':
        return compressStr(msg?.text || msg?.body?.text);
      case 'BUTTONS':
      case 'LIST':
      case 'ADDRESS':
        return compressStr(msg?.text || msg?.body?.text);
      case 'VIDEO':
        return '📹 Video';
      case 'IMAGE':
        return '🖼️ Image';
      case 'DOCUMENT':
        return '📄 Document';
      case 'AUDIO':
        return '🎵 Audio';
      default:
        return compressStr(msg?.text || msg?.body?.text || type);
    }
  };

  const showLastMessage = (item) => {
    if (!item) return '';
    const lastMsg = item?.last_message;
    const adminMsg = item?.admin_message;
    let messageToDisplay = '';

    if (lastMsg) {
      messageToDisplay = getMessageData(lastMsg);
      if (lastMsg.origin === 'OUTBOUND') {
        messageToDisplay = `[Admin] ${messageToDisplay}`;
      }
    } else if (adminMsg) {
      messageToDisplay = `[Admin] ${getMessageData(adminMsg)}`;
    }
    return messageToDisplay || 'No recent message';
  };

  const filteredUsers =
    userList?.users?.filter((item) => {
      if (filters?.userType === 'intervene') {
        return item?.intervene === true;
      }
      if (filters?.userType === '15-min') {
        return item?.intervene === false || item?.intervene == null;
      }
      if (filters?.userType === 'active') {
        return !item?.intervene;
      }
      return true;
    }) ?? [];

  return (
    <>
      {/* <div className="search-area">
        <div className="search-area-form gap-2 d-grid"> */}
      {filters?.channelObj?.app_name &&
        (filters?.channelObj?.wa_phone_number || filters?.channelObj?.channel_number) && (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '10px 12px',
              border: '1px solid #223386',
              borderRadius: '8px',
              width: '100%',
              backgroundColor: '#405FF2',
              // boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
              mb: 0.5,
              mt: 0,
            }}
          >
            <Typography
              component="span"
              variant="h6"
              sx={{ fontWeight: '500', color: '#fff', fontSize: '16px' }}
            >
              {`${filters.channelObj.app_name} - ${filters?.channelObj?.wa_phone_number || filters?.channelObj?.channel_number}`}
            </Typography>
            {/* <IconButton
              onClick={() => {
                setModalOpen(true);
                setIsEditModeModal(true);
                fetchOrganisations(organisationFilter);
              }}
              size="medium"
              sx={{
                border: '0.5px solid #1A3EEA',
                backgroundColor: '#6882FF',
                color: '#fff',
                padding: '4px',
                '&:hover': { backgroundColor: '#879cff' },
              }}
              disabled={editIconEnable}
            >
              <EditIcon />
            </IconButton> */}
            {!editIconEnable && (
              <IconButton
                onClick={() => {
                  setModalOpen(true);
                  setIsEditModeModal(true);
                  fetchOrganisations(organisationFilter);
                }}
                size="medium"
                sx={{
                  border: '0.5px solid #1A3EEA',
                  backgroundColor: '#6882FF',
                  color: '#fff',
                  padding: '4px',
                  '&:hover': { backgroundColor: '#879cff' },
                }}
              >
                <EditIcon />
              </IconButton>
            )}
          </Box>
        )}
      <Box
        sx={{
          mb: { xs: '5px', sm: '5px', md: '5px' },
          mt: { xs: 1, sm: 1, md: 1 },
          borderBottom: '1px solid #ccc',
          pr: 2,
          '& .css-1tmwr6f': {
            border: 'none !important',
            display: 'flex',
            flexDirection: 'row-reverse',
          },
        }}
      >
        {/* <SearchBox handleSearch={handleSearch} value={filters?.search || ''} 
            placeholder="Messages" /> */}

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '3px',
            paddingBottom: '10px',
          }}
        >
          <TextField
            placeholder="Search User"
            value={filters?.search || ''}
            onChange={(e) => handleSearch(e.target.value)}
            size="small"
            fullWidth
            InputProps={{
              sx: {
                '& input::placeholder': {
                  color: '#404040', // Change this to your desired color
                  opacity: 1,
                  fontWeight: 500,
                },
                color: '#000',
              },
            }}
            sx={{
              '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': { border: 'none' },
            }}
          />
          <SearchIcon />
        </Box>
      </Box>
      {/* <div className="filter-wrapper">
            <SearchBox onSearch={handleSearch} value={filters?.search} />
          </div> */}
      {/* </div>
      </div> */}
      {/* <div className="d-flex justify-content-around">
        {actions?.userTypesList?.map((item, index) => {
          return (
            <span
              key={index}
              onClick={() => {
                changeUserType(item?.value);
              }}
              className={`fw-bold position-relative pb-1 ${filters?.userType === item?.value ? 'border-bottom border-primary border-4 ' : 'border-bottom-light'}`}
              style={{
                cursor: 'pointer',
                color: filters?.userType === item?.value ? 'var(--bs-primary)' : 'var(--bs-dark)',
              }}
            >
              {item?.label}
            </span>
          );
        })}
      </div> */}
      <Box sx={{ width: '100%', bgcolor: 'background.paper', px: '5px' }}>
        <Tabs
          value={filters?.userType}
          onChange={(e, value) => changeUserType(value)}
          // variant="scrollable"
          scrollButtons="auto"
          aria-label="User type filters"
          textColor="inherit"
          indicatorColor="secondary"
          sx={{
            '& .MuiTabs-list': { justifyContent: 'space-between' },
            '& .MuiTabs-indicator': { display: 'none' },
            '& .MuiTab-root': { minHeight: 60, minWidth: 'auto', p: 0, mx: '3px' },
          }}
        >
          {actions?.userTypesList?.map((item) => {
            const key = TAB_KEY_MAP[item.value];
            const count = chatCounts[key] ?? 0;
            const selected = filters?.userType === item.value;
            return (
              <Tab
                key={item.value}
                value={item.value}
                disableRipple
                label={<TabPillLabel text={item.label} count={count} selected={selected} />}
              />
            );
          })}
        </Tabs>
      </Box>
      <Box
        sx={{
          height: 'calc(100vh - 264px)',
          pt: 1,
          pb: 1,
          maxHeight: {
            sm: 'calc(95vh - 264px)',
            md: 'calc(95vh - 264px)',
            lg: 'calc(97vh - 264px)',
            xl: 'calc(100vh - 264px)',
          },
          overflowY: 'auto',
          overflowX: 'hidden',
        }}
        onScroll={(e) => onScroll()}
        ref={listInnerRef}
      >
        {isDataLoading ? (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100%',
            }}
          >
            <CircularProgress size={32} />
          </Box>
        ) : filteredUsers.length > 0 ? (
          <List sx={{ width: '100%', bgcolor: 'background.paper', p: 0, height: '100%' }}>
            {filteredUsers.map((item: any, index) => {
              const lastMsg = showLastMessage(item);
              const isActive = userDetails?.phone_number === item?.phone_number;
              const hasValidName =
                item?.whatsapp_name &&
                typeof item.whatsapp_name === 'string' &&
                item?.whatsapp_name?.trim() !== '';
              return (
                <React.Fragment key={item.phone_number || index}>
                  <ListItem
                    className="count-wrapper"
                    alignItems="flex-start"
                    onClick={() => onSelectUser(item, index)}
                    sx={{
                      paddingLeft: '8px',
                      paddingRight: '119px',
                      gap: '5px',
                      cursor: 'pointer',
                      backgroundColor: isActive ? '#F5F7F9 !important' : 'transparent',
                      '&:hover': {
                        backgroundColor: isActive ? '#F5F7F9 !important' : 'action.hover',
                      },
                      // Apply a border or different background for active chat
                      // borderLeft: isActive ? '4px solid primary.main' : 'none',
                      // p: 1.5, // Adjust padding as needed
                    }}
                    secondaryAction={
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'flex-end',
                          gap: '4px',
                          top: '50%',
                          transform: 'translateY(-50%)',
                          position: 'absolute',
                          right: '8px',
                        }}
                      >
                        {item?.last_active_date && (
                          <Countdown lastActive={item?.last_active_date} />
                        )}
                        {filters?.userType === 'intervene' && item?.intervened_by && (
                          <Tooltip
                            title={item.intervened_by}
                            arrow
                            placement="top"
                            enterDelay={300}
                          >
                            <Box>
                              <CommonBadges
                                icon={<SensorsIcon sx={{ fontSize: '13px !important' }} />}
                                value={
                                  item.intervened_by.length > 15
                                    ? item.intervened_by.substring(0, 15) + '...'
                                    : item.intervened_by
                                }
                                variant="outlined"
                                style={{
                                  border: '1px solid #19221dff',
                                  fontSize: '10px',
                                  fontWeight: 400,
                                  height: '20.5px',
                                  lineHeight: '1',
                                  color: '#19221dff',
                                  background: '#E6F4EA',
                                }}
                              />
                            </Box>
                          </Tooltip>
                        )}
                      </Box>
                    }
                  >
                    <ListItemAvatar sx={{ minWidth: '34px' }}>
                      <Badge
                        badgeContent={item?.not_read_count > 0 ? item.not_read_count : null}
                        color="error"
                        overlap="circular"
                        size="small"
                        anchorOrigin={{
                          vertical: 'top',
                          horizontal: 'right',
                        }}
                        sx={{
                          '& .MuiBadge-badge': {
                            fontSize: '10px',
                            minWidth: '16px',
                            height: '18px',
                            fontWeight: 400,
                            top: '1px',
                            right: '7px',
                          },
                        }}
                      >
                        <MuiAvatar
                          alt={item?.whatsapp_name || item?.phone_number}
                          src={hasValidName ? undefined : Avatar} // Show image only if no valid name for letter
                          // sx={{
                          //   // Optionally, add a background color if displaying a letter.
                          //   // MUI might pick one, or you can set it explicitly.
                          //   bgcolor: hasValidName ? '#d9d9d9' : undefined,
                          //   color: hasValidName ? 'common.black' : undefined,
                          //   minWidth: '34px',
                          // }}
                          sx={{
                            bgcolor: hasValidName ? 'primary.main' : undefined,
                            color: hasValidName ? 'primary.contrastText' : undefined,
                            minWidth: '34px',
                          }}
                        >
                          {hasValidName ? item.whatsapp_name.trim()[0].toUpperCase() : null}
                        </MuiAvatar>
                        <Badge
                          color="#008F3C"
                          variant="dot"
                          sx={{
                            position: 'absolute',
                            background: '#008F3C',
                            width: '10px',
                            height: '10px',
                            borderRadius: ' 20px',
                            bottom: 0,
                            right: 0,
                          }}
                        ></Badge>
                      </Badge>
                    </ListItemAvatar>
                    <ListItemText
                      primary={
                        <Typography
                          variant="subtitle1"
                          component="div"
                          noWrap
                          sx={{ fontWeight: 'medium' }}
                        >
                          {item?.whatsapp_name || item?.phone_number}
                        </Typography>
                      }
                      secondary={
                        <Typography
                          variant="body2"
                          color="text.secondary"
                          noWrap
                          component="span"
                          sx={{ display: 'block' }}
                        >
                          {lastMsg?.trim() ? lastMsg : 'No recent message'}
                        </Typography>
                      }
                      sx={{ mr: item?.last_active_date ? 1 : 0 }} // Add margin if countdown is present
                    />
                  </ListItem>
                  {index < userList.users.length - 1 && (
                    <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                      <Box
                        sx={{
                          // borderBottom: '1px solid #E0E0E0',
                          width: 'calc(100% - 72px)',
                          ml: '72px',
                        }}
                      />
                    </Box>
                    // <Divider variant="inset" component="li" sx={{ ml: '72px' }} /> // Alternative divider
                  )}
                </React.Fragment>
              );
            })}
          </List>
        ) : (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
            <DataNotFound />
          </Box>
        )}
      </Box>
      {isModalOpen && (
        <OrganisationBotSelectionModal
          open={isModalOpen}
          onClose={handleCloseModal}
          isEdit={isEditModeModal}
          selectedOrganisation={filters?.organisationObj || null}
          selectedBot={filters?.channelObj || null}
        />
      )}
    </>
  );
};

export default UserList;
